import { Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { FailedComponent } from './core/components/failed/failed.component';
import { ShellComponent } from './layout/shell/shell.component';
import { GlobalGuard } from './core/guards/global.guard';

// Rutas top-level de la aplicación.
export const APP_ROUTES: Routes = [
    {
        path: 'login-failed',
        component: FailedComponent
    },
    {
        path: '',
        component: ShellComponent,
        canActivate: [MsalGuard, GlobalGuard],
        children: [
            {
                path: 'digital',
                loadChildren: () => import('./modules/profiles/notary/notary.routes').then(m => m.NOTARY_ROUTES),
            },
            {
                path: 'kams',
                loadChildren: () => import('./modules/profiles/kams/kams.routes').then(m => m.KAMS_ROUTES),
            },
            {
                path: 'back-office',
                loadChildren: () => import('./modules/profiles/admin/admin.routes').then(m => m.ADMIN_ROUTES),
            },
            {
                path: 'laser',
                loadChildren: () => import('./modules/profiles/laser/laser.routes').then(m => m.LASER_ROUTES),
            },
            {
                path: 'followup',
                loadChildren: () => import('./modules/profiles/followup/followup.routes').then(m => m.FOLLOWUP_ROUTES),
            },
            {
                path: 'bomberos',
                loadChildren: () => import('./modules/profiles/bombero/bombero.routes').then(m => m.BOMBERO_ROUTES),
            },
            {
                path: 'asistente-administrativo',
                loadChildren: () => import('./modules/profiles/administrative-assistant/administrative-assistant.routes').then(m => m.ADMINISTRATIVE_ASSISTANT_ROUTES),
            },
             {
              path: 'csa',
              loadChildren: () => import('./modules/profiles/csa/csa.routes').then(m => m.CSA_ROUTES),
            },
            {
                path: 'pivot',
                loadChildren: () => import('./modules/profiles/pivot/pivot.routes').then(m => m.PIVOT_ROUTES),
            },
            {
                path: '',
                redirectTo: 'profile',
                pathMatch: 'full'
            }
        ]
    },
    {
        path: '**',
        redirectTo: 'profile'
    }
];
